import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { SelectButtonModule } from 'primeng/selectbutton';
import { VenueMapComponent } from './venue-map.component';

@NgModule({
  declarations: [VenueMapComponent],
  imports: [CommonModule, FormsModule, AutoCompleteModule, ButtonModule, DropdownModule, SelectButtonModule],
  exports: [VenueMapComponent],
})
export class VenueMapModule {}
